export class Voucher {

  id;
  keyword: string;
  value;
  type: string;
  date: number | any;
  pieces: number;

}
